import streams from "../apis/streams";

const LoadS3Keys = prefix => {
  return async function(dispatch, getState) {
    const response = await streams.get(`S3Content/${prefix}`);
    dispatch({ type: "LOAD_KEYS", payload: response.data });
  };
};

export default LoadS3Keys;
